import animationEnhancements from './animation-enhancements';
import tabs from './tabs';
import elements from "./elements/all";

export default function() {
    animationEnhancements();
    elements();
    
    // isn't updated for all pages yet
    if ($('.menu-topbar__link').length) tabs();
}
